import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";

export interface SendLinkedInConnectionRequestParams {
  identifier: string;
  accountId: string;
  message?: string;
  contactId?: string;
}

export function useSendLinkedInConnectionRequest() {
  const queryClient = useQueryClient();

  const sendConnectionRequestMutation = useMutation({
    mutationFn: async (params: SendLinkedInConnectionRequestParams) => {
      const response = await Unipile.sendConnectionRequest(params.identifier, {
        account_id: params.accountId,
        message: params.message,
        contactId: params.contactId,
      });

      if (!response.data?.status) {
        const errorData = response.data as any;
        throw new Error(
          errorData?.message || errorData?.msg || "Failed to send LinkedIn connection request"
        );
      }

      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["linkedin-connection-status", variables.accountId, variables.identifier],
      });

      queryClient.invalidateQueries({
        queryKey: ["linkedin-chat-by-contact"],
      });
    },
  });

  return {
    sendConnectionRequest: sendConnectionRequestMutation.mutateAsync,
    isSending: sendConnectionRequestMutation.isPending,
    sendError: sendConnectionRequestMutation.error,
  };
}
